import ApiClient from './ApiClient';

class HotelRoomsAPI extends ApiClient {
  constructor() {
    super('hotel_rooms', { accountScoped: true });
  }
}

export default new HotelRoomsAPI();
